/**
 * Resolves invalidation templates by replacing `{param}` placeholders
 * with actual values from mutation variables.
 */
export function resolveInvalidationTemplates(
  templates: readonly (readonly unknown[])[],
  variables: unknown
): (readonly unknown[])[] {
  const vars = variables as Record<string, unknown>;
  return templates.flatMap(template => {
    const resolved = template.map(segment => {
      if (typeof segment !== 'string') return segment;
      return segment.replace(/\{(\w+)\}/g, (_, paramName: string) => {
        const variableName = paramName.replace(/_([A-Za-z0-9])/g, (_match, character: string) =>
          character.toUpperCase()
        );
        const value = vars[paramName] === undefined ? vars[variableName] : vars[paramName];
        if (value === undefined) {
          console.warn(`Missing placeholder value for {${paramName}}`);
          return `{${paramName}}`;
        }
        return String(value);
      });
    });
    return [resolved];
  });
}
